import http from '@/utils/http'
import { ParamObject, TranslateAllLangReq, TranslateReq } from '@/model'

export default ParamObject

export const getUserInfo = (p: object) => http.get('userinfo', 'api/weekly', p)

export const getTaskList = (p: ParamObject) => http.post('growth_tinfo', 'api/service', p)

export const getAchievement = (p: ParamObject) => http.post('growth_ainfo', 'api/service', p)

export const getCardUserInfo = (p: ParamObject) => http.post('growth_binfo', 'api/service', p)

export const postReward = (p: ParamObject) => http.post('growth_reward', 'api/service', p)

export const getMallList = (p: ParamObject) => http.post('growth_minfo', 'api/service', p)

export const getHistoryList = (p: ParamObject) => http.post('growth_history', 'api/service', p)

export const postBuy = (p: ParamObject) => http.post('growth_exchange', 'api/service', p)

export const getLiveList = (p: ParamObject) => http.post('live_getinfo', 'api/service', p)

export const translate = (p: TranslateReq) => http.post('translate', 'api/service', p)

export const translate_all = (p: TranslateAllLangReq) => http.post('translate_all', 'api/service', p)

export const uploadFile = (p: object) => http.post('translate', 'api/service', p, {}, {'Content-Type':'multipart/form-data'});

export const getClubDetail = (p: object) => http.post('mainpage', 'sns/club', p);

export const getEncryptinfo = (p: object) => http.post('encryptinfo', 'sns/user', p);

export const verifyCode = (p: object) => http.post('kol_verify_code', 'sns/activity', p);

export const bindCode = (p: object) => http.post('kol_bind_code', 'sns/activity', p);

export const getFeedDetail = (p: object) => http.post('detail', 'feed/feed', p);

export const getComment = (p: object) => http.post('list', 'comment/comment', p);

export const getRaceDetail = (p: object) => http.post('detail', 'tournaments', p);

export const getUploadConfig = (p: any) => http.post('public_upload_config', 'config', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});

export const getCertificationUserInfo = (p: object) => http.post('certification_user', 'api/service', p);

export const getCertificationClubInfo = (p: object) => http.post('certification_club', 'api/service', p);

export const takeCertificationClubRequest = (p: object) => http.post('certification_saveclub', 'api/service', p);

export const takeCertificationUserRequest = (p: object) => http.post('certification_saveuser', 'api/service', p);

export const getReviewTask = (p: any) => http.post('get_task', 'feed/audit', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket})

export const submitReviewTask = (p: any) => http.post('submit_task', 'feed/audit', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket})

export const getUserReviewDaySummary = (p: any) => http.post('user_day_summary', 'feed/audit', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket})

export const saveFeedback = (p: object) => http.post('certification_savefeedback', 'api/service', p);

export const getClubRanking = (p: any) => http.post('get_in_club_ranking', 'sns/club', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});

export const getClubPref = (p: any) => http.post('get_user_club_pref', 'sns/club', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});

export const setClubPref = (p: any) => http.post('set_user_club_pref', 'sns/club', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
// headOpenid 区分主客态时需要
export const getClubAchievement = (p: any) => http.post('list', 'achievement', p, {}, {openid: p.headOpenid, lang: p.lang, ticket: p.ticket});

export const getClubAchievementPref = (p: any) => http.post('getsetting', 'sns/user', p, {}, {openid: p.headOpenid, lang: p.lang, ticket: p.ticket});

export const setClubAchievementPref = (p: any) => http.post('setting', 'sns/user', p, {}, {openid: p.headOpenid, lang: p.lang, ticket: p.ticket});

// 私密空间api
export const getZone = (p: any) => http.post('get', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
export const setZone = (p: any) => http.post('set', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
//解散
export const disbandtZone = (p: any) => http.post('disband', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
// 邀请列表
export const candidates = (p: any) => http.post('candidates', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
export const invite = (p: any) => http.post('invite', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
// 受邀请列表
export const invitations = (p: any) => http.post('invitations', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
// 处理邀请
export const onInvitation = (p: any) => http.post('on_invitation', 'zone', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
// feeds
export const feedList = (p: any) => http.post('v2', 'feed/list', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});
export const feedDelete = (p: any) => http.post('delete', 'feed', p, {}, {openid: p.openid, lang: p.lang, ticket: p.ticket});

// 媒体认证
export const getMediaAuthInfo = (p: any) => http.post('get', 'ugc/influence', p, {}, {uid: p.uid, openid: p.openid, lang: p.lang, ticket: p.ticket, region: p.region, pkgname: p.pkgName});
export const saveMediaAuth = (p: any) => http.post('apply', 'ugc/influence', p, {}, {uid: p.uid, openid: p.openid, lang: p.lang, ticket: p.ticket, region: p.region, pkgname: p.pkgName});

// 编辑器玩法认证
export const saveEditorAuth = (p: any) => http.post(
    'submit_related_exp', 
    'ugc', 
    p, 
    {}, 
    {uid: p.uid, openid: p.openid, lang: p.lang, ticket: p.ticket, region: p.region, appversion: p.appversion, os: p.os}
);

export const getClubFeedList = (p: any) => http.post('list/v2', 'feed', p, {}, {uid: p.uid, openid: p.openid, lang: p.lang, ticket: p.ticket, region: p.region, pkgname: p.pkgName});
export const getTopicFeedList = (p: any) => http.post(`topicfeedlist`, 'feed', p, {}, {uid: p.uid, openid: p.openid});